import { connect } from 'react-redux';
import Finish from './components';
import { Creators } from '../../../services/redux/user/actions';

const mapStateToProps = state => {
	const { referenceno } = state.document;
  return {
  	referenceNumber: referenceno
  };
};

const mapDispatchToProps = dispatch => {
  return {
  	finish: () => {
  		dispatch(Creators.clearState());
  	}
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Finish);

